import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const EditPlaylistDirective = angularDirectiveToReact('editPlaylist', { playlistId: '<' });

export function EditPlaylistComponent() {
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{ playlistId: string }>();

    return <EditPlaylistDirective key={key} {...params} />;
}
